import { GroupMark } from "@/components/GroupMark";

/* Official IDEAL REAL ESTATE logo.
   theme "ink"  -> transparent variant (black + beige) for light surfaces
   theme "sand" -> transparent variant with light text, for dark surfaces (hero header, footer) */
export const Logo = ({ theme = "ink", className = "" }) => (
  <img
    src={theme === "ink" ? "/logo-transparent.png" : "/logo-light.png"}
    alt="Ideal Real Estate — Dove l'ideale prende forma"
    className={`h-12 w-auto ${className}`}
    draggable="false"
  />
);

export { GroupMark };

export default Logo;
